export const hasCountryField = (item?: string | Array<string>) => {
  if (!item) return false

  const countryValue = Array.isArray(item) ? item[0] : item

  return ['onsite-support', 'both-support'].includes(countryValue)
}
